import * as actionTypes from "../constants/actionTypes";
import initialState from "./initialState/authDrawer";
import update from "immutability-helper";

export default (state = initialState, action) => {
  switch (action.type) {
    case (actionTypes.AUTH_DRAWER_OPEN): {
      return Object.assign({}, state, {
        authDrawerOpen: action.payload,
      });
    }

    case (actionTypes.CHANGE_STEP): {
      return Object.assign({}, state, {
        step: action.payload,
      });
    }

    case (actionTypes.EMAIL_NOT_AVAILABLE): {
      return Object.assign({}, state, {
        emailAvailable: false,
      });
    }

    case (actionTypes.EMAIL_AVAILABLE): {
      return Object.assign({}, state, {
        emailAvailable: true,
      });
    }

    case (actionTypes.SET_BASIC_INFO): {
      return Object.assign({}, state, {
        userData: action.payload,
      });
    }

    case (actionTypes.SET_OPTIONAL_INFO): {
      return update(state, {
        userData: {
          $merge: action.payload,
        },
      });
    }

    case (actionTypes.CREATE_USER_SUCCESS): {
      return Object.assign({}, state, {
        authToken: action.payload["gigster-token"],
      });
    }

    case (actionTypes.SET_PASSWORD_RESET_INFO): {
      return Object.assign({}, state, {
        passwordResetToken: action.payload.token,
        passwordResetEmail: action.payload.email,
      });
    }

    case (actionTypes.SET_AUTH_TOKEN): {
      return Object.assign({}, state, {
        authToken: action.payload,
        loggedIn: true,
      });
    }

    case (actionTypes.REMOVE_AUTH_TOKEN): {
      return Object.assign({}, state, {
        authToken: null,
        loggedIn: false,
      });
    }

    case (actionTypes.LOGGED_IN_STATUS): {
      return Object.assign({}, state, {
        loggedIn: action.payload,
      });
    }

    case (actionTypes.EMAIL_CONFIRM_SUCCESS): {
      return Object.assign({}, state, {
        emailConfirmed: true,
      });
    }

    case (actionTypes.EMAIL_CONFIRM_ERROR): {
      return Object.assign({}, state, {
        emailConfirmError: true,
      });
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authDrawer.js